import { useAllFaQsQuery } from "@/gql/generated-types"
import { CollapseOverWrite } from "@/modules/becomeMember/components/Collapse"
import { Flex } from "@mantine/core"
import { useRouter } from "next/router"
import { FC } from "react"

export const FAQs: FC = () => {
  const { locale } = useRouter()
  const { data } = useAllFaQsQuery({ variables: { locale }, fetchPolicy: "network-only" })

  return (
    <Flex p={0} m={0} w={"100%"} direction={"column"}>
      {data?.faqs?.data?.map((i, k) => (
        <CollapseOverWrite key={k} title={i.attributes?.question ?? ""} description={i.attributes?.answer ?? ""} />
      ))}
    </Flex>
  )
}
